const COLORS: [string, string][] = [
  ["bg-orange-500/20", "text-orange-300"],
  ["bg-emerald-500/20", "text-emerald-300"],
  ["bg-sky-500/20", "text-sky-300"],
  ["bg-violet-500/20", "text-violet-300"],
  ["bg-rose-500/20", "text-rose-300"],
  ["bg-amber-500/20", "text-amber-300"],
  ["bg-teal-500/20", "text-teal-300"],
  ["bg-fuchsia-500/20", "text-fuchsia-300"],
];

// Known providers get a stable color so "anthropic" is always the same orange.
const PINS: Record<string, number> = {
  anthropic: 0,
  openai: 1,
  openrouter: 3,
  gemini: 2,
  google: 2,
  finnhub: 4,
  alphavantage: 5,
  polygon: 2,
  twelvedata: 6,
  chatwoot: 7,
  stripe: 3,
  github: 5,
  gitlab: 4,
  slack: 1,
  twilio: 4,
  fireflies: 7,
  "2captcha": 5,
  serpapi: 6,
  resend: 1,
  sendgrid: 3,
  mistral: 5,
  groq: 0,
  deepseek: 2,
  perplexity: 7,
  oxylabs: 6,
  cloudflare: 0,
  railway: 3,
};

function hashToColor(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h) % COLORS.length;
}

export function ProviderGlyph({
  provider,
  size = 28,
}: {
  provider: string;
  size?: number;
}) {
  const key = provider.toLowerCase().trim();
  const idx = PINS[key] ?? hashToColor(key);
  const [bg, fg] = COLORS[idx];
  const letter = (key.match(/[a-z0-9]/i)?.[0] ?? "?").toUpperCase();
  return (
    <span
      className={`inline-flex items-center justify-center rounded-md font-semibold ${bg} ${fg}`}
      style={{ width: size, height: size, fontSize: size * 0.44 }}
      title={provider}
      aria-label={`${provider} glyph`}
    >
      {letter}
    </span>
  );
}
